import { http } from '../helpers/http'

const findAll = () => {
  return http.get('/origins')
}

const find = originId => {
  return http.get(`/origin/${originId}`)
}

const create = origin => {
  return http.post(`/origins`, { label: origin })
}

const update = (originId, origin) => {
  return http.patch(`/origin/${originId}`, { label: origin })
}

const remove = originId => {
  return http.delete(`origin/${originId}`)
}

export const originService = {
  findAll,
  find,
  create,
  update,
  remove
}
